module.exports = __webpack_public_path__ + "static/media/inkHair.d2dcda11.jpg";